import Iconify, { type IconifyProps } from 'components/Iconify';

type Props = Omit<IconifyProps, 'icon'>;

export const DownloadIcon = (props: Props) => {
  return <Iconify icon="material-symbols:download-rounded" {...props} />;
};
